/**
 * Replaces a string placeholders with their values
 * @param {string} str The string containing the placeholders
 * @param {string | array | number} replacers Array of values to replace the placeholders with
 *
 * @returns {string} String with placeholders values
 * Example: replaceStringPlaceholders('You have {0} discount', '$99.99' ) => 'You have $99.99 discount'
 *
 */
const replaceStringPlaceholders = (str, replacers) => {
    if (!str) {
        return '';
    }
    let newStr = str;
    const regex = /{[\d]}/g;
    const placeholders = str.match(regex) || undefined;
    if (!Array.isArray(replacers) && (replacers || replacers === 0)) {
        newStr = newStr.replace(placeholders, replacers.toString());
    }
    else if (Array.isArray(placeholders) && replacers) {
        placeholders.forEach((placeholder) => {
            const indexOfReplacement = placeholder[1];
            const replacement = replacers[indexOfReplacement];
            if (replacement !== null && replacement !== undefined) {
                newStr = newStr.replace(placeholder, replacement);
            }
        });
    }
    return newStr;
};
export default replaceStringPlaceholders;
//# sourceMappingURL=replaceStringPlaceholders.js.map